import QuantityCounter from './QuantityCounter';

export default QuantityCounter;
